import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";

const EtsyConnectModal = ({ show, onHide }) => {
  const [shopName, setShopName] = useState("");

  const handleConnect = () => {
    if (!shopName.trim()) {
      toast.error("Please enter shop name");
      return;
    }

    const backendUrl =
      process.env.REACT_APP_API_URL || "https://api.kiashaajewellery.com";

    // Redirect to backend OAuth
    window.location.href = `${backendUrl}/etsy/oauth/connect?shop_name=${encodeURIComponent(
      shopName,
    )}`;
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Connect Etsy Shop</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group>
          <Form.Label>Etsy Shop Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="e.g. yourshopname"
            value={shopName}
            onChange={(e) => setShopName(e.target.value)}
          />
          <small className="text-muted">Enter the exact Etsy shop name</small>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>

        <Button variant="primary" onClick={handleConnect}>
          Connect with Etsy
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EtsyConnectModal;
